import React, { useEffect, useState } from "react";
import { padalaServices } from "../services/PadalaServices";
import { adminServices } from "../services/AdminServices";
import DataTable, { Alignment } from "react-data-table-component";
import { ReactComponent as TransactionIcon } from "../icons/receipt.svg";
import LoadingModal from "../components/LoadingModal";
import Button from '../components/Button';
import SearchBar from "../components/SearchBar";
import { formatCurrency } from "../tools/tool";
import InputText1 from "../components/InputText1";
import UnauthorizedComponent from "../components/UnauthorizedComponent";
import { v4 as uuidv4 } from 'uuid';
import Modal from "react-modal";
import AlertModal from "../components/AlertModal";
import withAuthorization from "../components/withAuthorization";
import MerchantList from "../components/MerchantList";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import { logExport } from "../services/ExportLogService";
const IPXTransactions = () => {
  const location = useLocation();
  const [kioskSales, setKioskSales] = useState(null);
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [grandTotal, setGrandTotal] = useState(0);
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const [makeTransfer, setMakeTransfer] = useState(false);
  const [transferAmount, setTransferAmount] = useState(0);
  const [formSeqNo, setFormSeqNo] = useState("");
  const [validationMessage, setValidationMessage] = useState("");
  const [isValidated, setIsValidate] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [pdlNumber, setPdlNumber] = useState('');
  const [remark, setRemark] = useState('');
  const [merchantName, setMerchantName] = useState('');
  const [pdlName, setPdlName] = useState('');
  const [merchantId, setMerchantId] = useState('');
  const [openMerchant, setOpenMerchant] = useState(false);
  const [selectedType, setSelectedType] = useState('all');
  const [walletValue, setWalletValue] = useState(0);
  const navigate = useNavigate();
  const customStyles = {
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.75)'
    },
    content: {
      width: '30%',
      margin: 'auto',
      height: '90%',
      backgroundColor: 'transparent',
      border: 0
    }
  };
  useEffect(() => {
    setLoading(true);
    IpxTransactions();
    const params = new URLSearchParams(location.search);
    const typeParam = params.get('type');
    if (typeParam) {
      setSelectedType(typeParam);
    }
  }, [location.search]);
  useEffect(() => {
    filterDataByType();
  }, [data, selectedType]);
  const filterDataByType = () => {
    let filtered = data;
    if (selectedType === 'all') {
      getIpxWallet();
      return;
    }
    if (selectedType !== 'all') {
      if (selectedType === 'kiosk') {
        filtered = data.filter(item => item.remarks && item.remarks.startsWith('Kiosk Purchases'));
      } else if (selectedType === 'pos') {
        filtered = data.filter(item => item.remarks && item.remarks.startsWith('POS Purchases'));
      } else if (selectedType === 'padala') {
        filtered = data.filter(item => item.remarks && item.remarks.toLowerCase().includes('padala via walk-in'));
      } else if (selectedType === 'merchant-padala') {
        filtered = data.filter(item => item.remarks && item.remarks.toLowerCase().includes('merchant padala fees'));
      } else if (selectedType === 'padala-app') {
        filtered = data.filter(item => item.remarks && item.remarks.toLowerCase().includes('padala via padala app'));
      } else if (selectedType === 'padala-ecpay') {
        filtered = data.filter(item => item.remarks && item.remarks.toLowerCase().includes('padala via ecpay'));
      } else if (selectedType === 'order-payment') {
        filtered = data.filter(item => item.remarks && item.remarks.toLowerCase().includes('order payment to ipx'));
      } else if (selectedType === 'transfer-to-merchant') {
        filtered = data.filter(item => item.remarks && item.remarks.startsWith('Transfer to Merchant'));
      } else if (selectedType === 'merchant-to-pdl') {
        filtered = data.filter(item => item.remarks && item.remarks.startsWith('Fund Transfer From Merchant:'));
      } else if (selectedType === 'pdl-to-merchant') {
        filtered = data.filter(item => item.remarks && item.remarks.startsWith('Fund Transfer From') && !item.remarks.startsWith('Fund Transfer From Merchant:'));
      } else if (selectedType === 'cash-out-request') {
        filtered = data.filter(item => item.remarks && item.remarks.startsWith('Cash Out Request'));
      }
    }
    setFilteredData(filtered);
    let gT = filtered.reduce((total, item) => total + item.amount, 0);
    setGrandTotal(gT);
    setWalletValue(gT);
  };
  const exportToCSV = async data => {
    if (!data || data.length === 0) return;

    // Log the export
    await logExport('IPX Transactions');
    const headers = ['Transaction Date', 'Reference No', 'Amount', 'Remarks'];
    const rows = data.map(row => [new Date(row.transaction_date).toLocaleString(), row.ref_no, row.amount,
    // raw numeric value
    row.remarks]);
    const csvContent = [headers, ...rows].map(row => row.map(field => `"${field}"`).join(',')).join('\n');
    const blob = new Blob([csvContent], {
      type: 'text/csv;charset=utf-8;'
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', 'IpxTransactionReport.csv');
    link.click();
  };
  const IpxTransactions = () => {
    getIpxWallet();
    adminServices.storeProcedure2('ipx_transactions_report', {}).then(r => {
      setKioskSales(null);
      setKioskSales(r.data);
      setData(r.data);
      setFilteredData(r.data);
      let gT = r.data.reduce((total, item) => total + item.amount, 0);
      setGrandTotal(gT);
      var _col = [{
        name: 'Transaction Date',
        selector: row => new Date(row.transaction_date).toLocaleString(),
        sortable: true,
        width: '250px'
      }, {
        name: 'Reference No',
        selector: row => row.ref_no,
        sortable: true,
        width: '150px'
      }, {
        name: 'Amount',
        selector: row => formatCurrency(row.amount),
        sortable: true,
        width: '200px',
        right: true
      }, {
        name: 'Remarks',
        selector: row => row.remarks.startsWith('Kiosk Purchases') ? "Kiosk Charge" : row.remarks.startsWith('POS Purchases') ? "POS Charge" : row.remarks,
        sortable: true
      }];
      setColumns(_col);
      setLoading(false);
    }).catch(error => {
      if (error.status === 401) {
        window.location.href = "/";
      }
    });
  };
  const getIpxWallet = async () => {
    let storedProcedure = 'ipx_wallet';
    let params = {};
    if (dateFrom && dateTo) {
      params = {
        dateFrom: dateFrom,
        dateTo: dateTo
      };
      storedProcedure = 'ipx_wallet_range';
    } else {
      params = {};
    }
    await adminServices.storeProcedure2(storedProcedure, params).then(response => {
      if (response.status == 200) {
        if (dateFrom && dateTo && Array.isArray(response.data)) {
          const total = response.data.reduce((sum, item) => sum + Math.abs(item.interest_fee || 0), 0);
          setWalletValue(total);
        } else {
          setWalletValue(response.data[0].interest_fee);
        }
      }
    }).catch(error => {
      if (error.status == 401) {
        navigate('/');
      }
      if (error.status == 429) {
        toast.error('Too many requests. will data will retry in 1 minute.');
        setTimeout(async () => {
          await getIpxWallet();
        }, 60000);
      }
    });
  };
  const KioskRange = () => {
    getIpxWallet();
    let params = {
      dateFrom: dateFrom,
      dateTo: dateTo
    };
    adminServices.storeProcedure2('ipx_transactions_report_range', params).then(r => {
      setKioskSales(null);
      setKioskSales(r.data);
      setData(r.data);
      setFilteredData(r.data);
      let gT = r.data.reduce((total, item) => total + item.amount, 0);
      setGrandTotal(gT);
      var _col = [{
        name: 'Transaction Date',
        selector: row => new Date(row.transaction_date).toLocaleString(),
        sortable: true,
        width: '250px'
      }, {
        name: 'Reference No',
        selector: row => row.ref_no,
        sortable: true,
        width: '150px'
      }, {
        name: 'Amount',
        selector: row => formatCurrency(row.amount),
        sortable: true,
        width: '200px',
        right: true
      }, {
        name: 'Remarks',
        selector: row => row.remarks.startsWith('Kiosk Purchases') ? "Kiosk Charge" : row.remarks.startsWith('POS Purchases') ? "POS Charge" : row.remarks,
        sortable: true
      }];
      setColumns(_col);
      setLoading(false);
    }).catch(error => {
      if (error.status === 401) {
        window.location.href = "/";
      }
    });
  };
  const handleSelectedRow = e => {
    setMerchantName(e.merchant_name);
    setPdlName(e.pdl_name);
    setMerchantId(e.id);
    setOpenMerchant(false);
  };
  const handleTransfer = () => {
    setMakeTransfer(true);
  };
  const validateForm = () => {
    if (merchantId === "") {
      setIsValidate(false);
      setValidationMessage("Select a merchant to transfer funds");
      return false;
    }
    if (transferAmount <= 0) {
      setIsValidate(false);
      setValidationMessage("Transfer Amount should be at least 1");
      return false;
    }
    if (formSeqNo === "") {
      setIsValidate(false);
      setValidationMessage("Form Sequence Number Required.");
      return false;
    }
    return true;
  };
  const handleSubmit = async () => {
    if (validateForm()) {
      setLoading(true);
      let uuid = uuidv4();
      let refNo = uuid.split('-')[4];
      let remarks = `Transfer to Merchant; Remarks:${remark}`;
      await adminServices.storeProcedure2('IPXFundTransfer', {
        p_merchant_id: merchantId,
        p_ref_no: refNo.toLocaleUpperCase(),
        p_amount: transferAmount,
        p_form_number: formSeqNo,
        p_remarks: remarks
      }).then(async response => {
        if (response.data[0].STATUS == "202") {
          setIsSuccess(true);
          setShowAlert(true);
          setAlertMessage("Transfer Funds to Merchant Success. Transaction Ref: " + refNo.toUpperCase());
        } else {
          setShowAlert(true);
          setAlertMessage("Error while transferring funds to IPX. Please try again later.");
          setIsSuccess(false);
        }
      }).catch(error => {
        if (error.status === 401) {
          window.location.href = "/";
        }
      }).finally(() => {
        setMakeTransfer(false);
        setLoading(false);
      });
    }
  };
  const handleClose = () => {
    setShowAlert(false);
    if (isSuccess) {
      window.location.href = "/ipx-transactions";
    }
  };
  return <div>
      <MerchantList token={localStorage.getItem('appToken')} isOpen={openMerchant} onClose={() => {
      setOpenMerchant(false);
    }} selectedInfo={handleSelectedRow} />
      <AlertModal show={showAlert} title="IPX Transactions" message={alertMessage} onClose={handleClose} />
      <LoadingModal show={loading} message={"Loading Kiosk Sales Report..."} />
      <Modal style={customStyles} isOpen={makeTransfer} onRequestClose={() => {
      setMakeTransfer(false);
    }}>
            <div className="card">
                <div className="card-header">Transfer to Merchant Wallet</div>
                <div className="card-body d-flex flex-column align-item-center">

                    <div className=" d-flex flex-column justify-content-center mb-5 mt-3">
                        <Button className="w-50" variant={"primary"} onClick={() => {
              setOpenMerchant(true);
            }}>Select Merchant</Button>

                        <div className="text-primary justify-content-center mt-3">
                          {merchantName}
                        </div>
                    </div>

                    <div className=" d-flex flex-column justify-content-center">
                      <InputText1 title={"Amount to Transfer"} onChange={e => {
              setValidationMessage("");
              setIsValidate(true);
              if (e.target.value == "e") {
                setIsValidate(false);
                setValidationMessage("Invalid Amount");
              }
              if (e.target.value == "") {
                setIsValidate(false);
                setValidationMessage("Transfer Amount should be at least 1");
              }
              if (e.target.value <= 0) {
                setIsValidate(false);
                setValidationMessage("Transfer Amount should be at least 1");
              }
              if (e.target.value > grandTotal) {
                setIsValidate(false);
                setValidationMessage("Transfer Amount cannot be greater than the wallet");
              }
              setTransferAmount(e.target.value);
            }} value={transferAmount} type="number" />
                    </div>

                    <div className=" d-flex flex-column justify-content-center">
                      <InputText1 title={"Form Sequence Number"} onChange={e => {
              const regex = /^[a-zA-Z0-9]*$/;
              if (regex.test(e.target.value)) {
                setFormSeqNo(e.target.value.toUpperCase());
              }
            }} value={formSeqNo} />
                    </div>

                    <div className=" d-flex flex-column justify-content-center">
                      <InputText1 title={"Remarks"} onChange={e => {
              setRemark(e.target.value);
            }} value={remark} placeholder={"(Optional)"} />
                    </div>

                    <div className="text-danger">
                        {!isValidated && validationMessage}
                    </div>
                </div>
                <div className="card-footer d-flex justify-content-end">
                    <Button variant={"success"} onClick={handleSubmit}>Submit</Button>
                    &nbsp;
                    <Button variant={"danger"} onClick={() => {
            setMakeTransfer(false);
          }}>Cancel</Button>
                </div>
            </div>
        </Modal>
      <div style={{
      fontSize: '1.5rem',
      fontWeight: 'bold',
      marginBottom: 10,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    }}>
        <div className="d-flex align-items-center">
          <TransactionIcon style={{
          width: "50px",
          height: "50px",
          marginRight: "10px",
          background: 'transparent'
        }} />
         IPX Transactions ({formatCurrency(walletValue)})
        </div>

         <div className="d-flex justify-content-end">
            <Button variant={"primary"} size={"lg"} onClick={handleTransfer}> Transfer to Merchant </Button>
          </div>
      </div>

      <div className="flexRow" style={{
      width: '50%'
    }}>
          <InputText1 title={"Date From"} type="date" value={dateFrom} onChange={e => {
        setDateFrom(e.target.value);
      }} />

         <InputText1 title={"Date To"} type="date" value={dateTo} onChange={async e => {
        setDateTo(e.target.value);
      }} />

          <div style={{
        marginTop: 18
      }}>
            <Button variant={"primary"} onClick={KioskRange}>Search</Button>
          </div>

      </div>

      <div className="flexRow" style={{
      width: '70%'
    }}>
          <SearchBar placeholder="Search IPX Transactions" onChange={e => {
        const value = e.target.value.toLowerCase();
        let baseData = data;
        if (selectedType !== 'all') {
          if (selectedType === 'kiosk') {
            baseData = data.filter(item => item.remarks && item.remarks.startsWith('Kiosk Purchases'));
          } else if (selectedType === 'pos') {
            baseData = data.filter(item => item.remarks && item.remarks.startsWith('POS Purchases'));
          } else if (selectedType === 'padala') {
            baseData = data.filter(item => item.remarks && item.remarks.toLowerCase().includes('padala via walk-in'));
          } else if (selectedType === 'merchant-padala') {
            baseData = data.filter(item => item.remarks && item.remarks.toLowerCase().includes('merchant padala fees'));
          } else if (selectedType === 'padala-app') {
            baseData = data.filter(item => item.remarks && item.remarks.toLowerCase().includes('padala via padala app'));
          } else if (selectedType === 'padala-ecpay') {
            baseData = data.filter(item => item.remarks && item.remarks.toLowerCase().includes('padala via ecpay'));
          } else if (selectedType === 'order-payment') {
            baseData = data.filter(item => {
              if (!item.remarks) return false;
              const remarks = item.remarks.toLowerCase();
              return remarks.includes('order payment to ipx') || remarks.includes('transfer');
            });
          } else if (selectedType === 'transfer-to-merchant') {
            baseData = data.filter(item => item.remarks && item.remarks.startsWith('Transfer to Merchant'));
          } else if (selectedType === 'merchant-to-pdl') {
            baseData = data.filter(item => item.remarks && item.remarks.startsWith('Fund Transfer To'));
          } else if (selectedType === 'pdl-to-merchant') {
            baseData = data.filter(item => item.remarks && item.remarks.startsWith('Fund Transfer From') && !item.remarks.startsWith('Fund Transfer From Merchant:'));
          } else if (selectedType === 'cash-out-request') {
            baseData = data.filter(item => item.remarks && item.remarks.startsWith('Cash Out Request'));
          }
        }
        const filtered = baseData.filter(item => Object.keys(item).some(key => item[key] && item[key].toString().toLowerCase().includes(value.toLowerCase())));
        setFilteredData(filtered);
        let gT = filtered.reduce((total, item) => total + item.amount, 0);
        setGrandTotal(gT);
        setWalletValue(gT);
      }} />
          <div style={{
        display: 'flex',
        alignItems: 'center',
        marginLeft: 10
      }}>
            <span style={{
          fontWeight: 'bold',
          marginRight: 8
        }}>Type:</span>
            <select value={selectedType} onChange={e => setSelectedType(e.target.value)} style={{
          padding: '6px 10px',
          border: '1px solid #ccc',
          borderRadius: '4px',
          fontSize: '14px',
          minWidth: '200px'
        }}>
              <option value="all">All Types</option>
              <option value="kiosk">Kiosk</option>
              <option value="pos">POS</option>
              <option value="padala">Padala via Walk-In</option>
              <option value="merchant-padala">Merchant Padala Fees</option>
              <option value="padala-app">Padala via Padala App</option>
              <option value="padala-ecpay">Padala via ECPay</option>
              <option value="order-payment">Order Payment to IPX</option>
              <option value="transfer-to-merchant">Transfer to Merchant</option>
              <option value="pdl-to-merchant">PDL to Merchant</option>
              <option value="merchant-to-pdl">Merchant to PDL</option>
              <option value="cash-out-request">Cash Out Request</option>
            </select>
          </div>
      </div>

      <div className="flexRow">
        <div className="flexRow filterDiv">
        </div>
        &nbsp;&nbsp;
        <div style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-end"
      }}>
        </div>
        <div className="spacer"></div>
        <Button variant={"success"} size={'xs'} onClick={() => exportToCSV(filteredData)}> Export to CSV </Button>
      </div>
        <br />
        <DataTable columns={columns} data={filteredData} pagination highlightOnHover style={{
      zIndex: 0
    }} />
      
    </div>;
};
export default withAuthorization(IPXTransactions, 23);